/* eslint-disable */
import { SaveCancelFooter } from '@/components/molecules'
import { ROUTES } from '@/utils/constants/routesConstants'
import { ReviewAccordion, ReviewActionHeader } from '@/containers'
import { useAppDispatch, useAppSelector } from '@/store'
import { PageHeader } from 'pepsico-ds'
import { useCallback, useEffect, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { setLanguages, setToastNotifications } from '@/store/slices/commonSlice'
import { ProgressIndicator, Breadcrumb, Modal } from '@/components/atoms'
import { getSalesTargetData, getSalesTargetsDownloadMedia, getSalesTargetsReporteDownload} from '@/services/salesTargets'
import {  setSalesTarget, setSalesTargetFormData, setSelectedType, setInitialTargetName, setRuleSet, setTargetType, setPageActiveTab, setSalesTargetUuid, resetSalesTarget } from '@/store/slices/salesTargetSlice'
import { useParams } from 'react-router-dom'
import { getDateFromISOString } from '@/utils/commons'
import { MODAL_TYPE } from '@/utils/constants/globalStyle'
import { TARGET_TYPES, TARGET_TYPES_OPTIONS } from '@/utils/constants/saleTargetConstants'
import { downloadCSVFiles, getDateWithTimeString } from '@/helpers/shadcn/utils'
import { Constants } from '@/utils/constants/commonConstants'
import { getDisplayContentLanguagesService } from '@/services/languageService'
import { useProductList } from '@/containers/ProductsContainer/SalesTargetProducts/useProductList'
import { deepMerge } from '@/helpers/deepMerge'
import enUS from '@/internationalization/i18n/en-us'
import { COUNTRY_CODES, COUNTRY_LANGUAGES_CODES } from '@/utils/constants/globalConstants'
import {useCategoryList} from '@/hooks/useCategoryList'
import { useSalesTargets } from '@/hooks/useSalesTargets'
export const SalesTargetReview = () => {
  const [isCancel, setIsCancel] = useState(false)
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const [categoryList, setCategoryList] = useState([])
  const {fetchCategoryList} = useCategoryList(false)
  const salesTargetData = useAppSelector(state => state.salesTarget)
  const [isOpenStoreListModal, setOpenStoreListModal] = useState(false)
  const [isReadOnly, setIsReadOnly] = useState(false)
  const { productListData, isLoading: isProductListLoading } = useProductList({ isReviewPage: true })
  const countryCode = useAppSelector(state => state.countryCode)?.countryCode
  const countryName = enUS?.COUNTRIES[countryCode] || ''
  const { handleDraft, handlePublish,onTemplateUpdate } = useSalesTargets()
  const PreRequisiteParent = {
    categoryTable: true,
    uploadFile: false
  }
  const PreRequisiteChild = {
    categoryTable: true,
    uploadFile: false
  }
  const [preRequisiteParentTab, setPreRequisiteParentTab] = useState({
    categoryTable: false,
    uploadFile: false
  })
  const [preRequisiteChildTab, setPreRequisiteChildTab] = useState({
    categoryTable: false,
    uploadFile: false
  })
  const productSelections = useAppSelector(state => state.salesTarget.productSelections)

  const [editModeProductIds, setEditModeProductIds] = useState({
    includedIds: [],
    excludedIds: [],
    childExcludedIds: [],
    childIncludedIds: []
  });
  const [salesTargetType, setSalesTargetType] = useState('')

  const getFilteredProducts = (tabType) => {
    if (!productListData?.data || !productListData?.data?.length || isProductListLoading) {
      return []
    }

    let excludedIds = []
    let includedIds = []

    const parentTabData = salesTargetData.tabWiseData?.parent;
    const childTabData = salesTargetData.tabWiseData?.child;

    if (tabType === 'parent') {
      const parentRuleData = parentTabData?.ruleSet?.rules?.[0];
      excludedIds = parentTabData?.excludedProducts || parentRuleData?.excludedProductIds || [];
      includedIds = parentTabData?.includedProducts || parentRuleData?.includedProductIds || [];
    } else if (tabType === 'child') {
      const childRuleData = childTabData?.ruleSet?.rules?.[0];
      excludedIds = childTabData?.excludedProducts || childRuleData?.excludedProductIds || [];
      includedIds = childTabData?.includedProducts || childRuleData?.includedProductIds || [];
    }

    if (excludedIds.length === 0 && includedIds.length === 0) {
      if (id) {
        if (tabType === 'child') {
          excludedIds = editModeProductIds.childExcludedIds || [];
          includedIds = editModeProductIds.childIncludedIds || [];
        } else {
          excludedIds = editModeProductIds.excludedIds || [];
          includedIds = editModeProductIds.includedIds || [];
        }
      }
      else if (productSelections) {
        if (tabType === 'parent') {
          excludedIds = productSelections?.parent?.excluded || []
          includedIds = productSelections?.parent?.included || []
        } else if (tabType === 'child') {
          excludedIds = productSelections?.child?.excluded || []
          includedIds = productSelections?.child?.included || []
        } else {
          excludedIds = productSelections?.all?.excluded || []
          includedIds = productSelections?.all?.included || []
        }
      } else {
        return []
      }
    }

    const relevantProductIds = [...excludedIds, ...includedIds]
    const filteredProducts = productListData.data
      .filter(product => relevantProductIds.includes(product.productId))
      .map(product => ({
        ...product,
        category: product.category_locale || product.category_en,
        brand: product.brand_locale || product.brand_en,
        included: includedIds.includes(product.productId)
      }))

    return filteredProducts
  }

  const [dataList, setListData] = useState({ ...salesTargetData })

  const displayContentLanguages = useAppSelector(state => state.common?.languages || [])
  const languages = COUNTRY_LANGUAGES_CODES[countryCode] || displayContentLanguages || []
  const [activeLanguage, setActiveLanguage] = useState('en')
  const handleTabClick = langCode => {
    setActiveLanguage(langCode)
  }


  const { id } = useParams();
  const [searchParams] = useSearchParams();
  const urlStatus = searchParams.get('status');
  const isPrerequisiteTarget =
    salesTargetData?.targetType === TARGET_TYPES.MonthlyTargetPrerequistite ||
    salesTargetData?.targetType === TARGET_TYPES.ProductTargetPrerequisite
  const isLayeredTarget = salesTargetData?.targetType === TARGET_TYPES.ProductTargetLayered || salesTargetData?.targetType === TARGET_TYPES.MonthlyTargetLayered
  const isMainTargetOrProdTarget = salesTargetData?.targetType === TARGET_TYPES.MainTarget || salesTargetData?.targetType === TARGET_TYPES.ProductTarget




  const handlePublishAction = async () => {
    await handlePublish(salesTargetData, isPrerequisiteTarget, categoryList, navigate, ROUTES)
  }
  const handleDraftAction = async () => {
    try {
      if (salesTargetData.targetName === null) {
        dispatch(setToastNotifications({ show: true, message: 'Target Name is required', type: 'error' }))
        return;
      }
      await handleDraft(salesTargetData, salesTargetData, isPrerequisiteTarget, 'review', { categoryListData: categoryList })
      navigate(ROUTES.SALES_TARGETS)
    } catch (error) {
      console.error('Error in handleDraft:', error);
      // Error handling is already done in the hook
    }
  }

  useEffect(() => {
    setListData(deepMerge(salesTargetData, dataList));
  }, [productListData, editModeProductIds]);

  const handleCancel = () => {
    setIsCancel(!isCancel)
  }
  const createFormData = obj => {

    const isLayeredTarget =
      TARGET_TYPES_OPTIONS[obj?.targetType] === TARGET_TYPES.MonthlyTargetLayered || TARGET_TYPES_OPTIONS[obj?.targetType] === TARGET_TYPES.ProductTargetLayered

    let activeDisplay = false;
    if (obj?.activeStartDate == obj?.displayStartDate &&
      obj?.activeEndDate == obj?.displayEndDate) {
      activeDisplay = true;
    }

    let duration = '';
     const isEgyptAndApplicableTarget = (countryCode === COUNTRY_CODES.EGYPT || countryCode === COUNTRY_CODES.KSA) && (obj?.targetType === TARGET_TYPES.MainTarget || obj?.targetType === TARGET_TYPES.ProductTarget);
    if(isEgyptAndApplicableTarget){
      duration = isEgyptAndApplicableTarget ? 'CUSTOM' : '';
    }

    const formData = {
      targetType: TARGET_TYPES_OPTIONS[obj?.targetType] ?? obj?.targetType,
      targetTypeValue: obj?.targetType,
      targetName: obj?.targetName,
      storeList: obj?.storeList,
      ruleSet: obj?.ruleSet,
      awardPointsImmedFlag: obj?.awardPointsImmedFlag,
      pointsDeliveryDate: getDateFromISOString(obj?.pointsDeliveryDate),
      targetDeliveryDate: getDateFromISOString(obj?.targetDeliveryDate),
      startDate: getDateFromISOString(obj?.activeStartDate),
      excludeTaxFromGoal: !obj?.VATIncluded,
      VATIncluded: obj?.VATIncluded,
      offlineOrdersIncluded: obj?.offlineOrdersIncluded,
      joinCampaignFlag: obj?.joinCampaignFlag,
      endDate: getDateFromISOString(obj?.activeEndDate),
      ignoreSkuList: obj?.ignoreSkuList,
      activeDisplay: activeDisplay,
      displayStartDate: getDateFromISOString(obj?.displayStartDate),
      displayEndDate: getDateFromISOString(obj?.displayEndDate),
      numberLevel: obj?.metadata?.numberLevel,
      numberMileStone: obj?.metadata?.numberMileStone,
      roundUpPointsFlag: obj?.roundUpPointsFlag,
      // targetMediaFile: [obj?.storeList],
      // this may require in future
      // roundOffValue: obj?.roundPointsValue,
      // roundOffValueValid: obj?.roundPointsValue > 0 ? true : false,
      roundOffValue:  obj?.roundPointsValue > 0? String(obj?.roundPointsValue): '',
      roundOffValueValid: obj?.roundPointsValue > 0 ? false : true,
      pointDisplay: isLayeredTarget ? obj?.pointDisplay : null,
      pointDisplayValid: isLayeredTarget ? false : null,
      duration: duration
    }
    return formData
  }

  // this will reset redux salestarget when its draft state
  const getComposedData = async (response) => {
    let composedData = {};
    const responseData  = response?.data?.content[0]?.versionData;
    const displayContentMedia = getDisplayContentMedia(responseData);
    let imageUri = null;
    if (doesImageUrlExists(responseData)) {
      imageUri = responseData?.media[0]?.imageUrl;
    }
    const displayContent = createDisplayContent(responseData);
    const childDisplayContentCopy = responseData?.child ? responseData?.child : {}
    const childDisplayContent = childDisplayContentCopy?.displayContent;
    composedData = {
      ...dataList, formData: createFormData(responseData),
      ...createFormData(responseData),
      ruleSet: responseData?.ruleSet,
      displayContent: {...displayContent,child:childDisplayContent},
      targetName: responseData?.targetName,
      child: {displayContent: childDisplayContent || {} },
      status: responseData?.status,
      pointDisplay: responseData?.pointDisplay,
      joinCampaignFlag: responseData?.joinCampaignFlag,
      uuid: responseData?.uuid || null,
      displayContentMedia: responseData?.media?.length > 0 ? {
        ...displayContentMedia,
        title: displayContentMedia?.title,
        imageUrl: displayContentMedia?.imageUrl,
        imageUri: imageUri,
        imageId: displayContentMedia?.imageId,
        optIn: displayContentMedia?.optIn,
      } : {},
      targetType: TARGET_TYPES_OPTIONS[responseData?.targetType],
      targetTypeValue: responseData?.targetType,
      tabWiseData: {
        parent: {
          includedProducts: responseData?.ruleSet?.rules?.[0]?.includedProductIds,
          excludedProducts: responseData?.ruleSet?.rules?.[0]?.excludedProductIds,
          ruleSet: responseData?.ruleSet,
          mediaFile: responseData?.metadata?.isProductIdsUploaded ? [responseData?.metadata?.productFileName] : [],
          selectedCategory: await transformCategories(responseData?.ruleSet),
          ignoreSkuList: responseData?.ignoreSkuList
        },
        child: {
          includedProducts: responseData?.child?.ruleSet?.rules?.[0]?.includedProductIds,
          excludedProducts: responseData?.child?.ruleSet?.rules?.[0]?.excludedProductIds,
          ruleSet: responseData?.child?.ruleSet,
          mediaFile: responseData?.child?.metadata?.isProductIdsUploaded ? [responseData?.child?.metadata?.productFileName] : [],
          selectedCategory: await transformCategories(responseData?.child?.ruleSet),
          ignoreSkuList: responseData?.child?.ignoreSkuList
        }
      },
      media: responseData?.media
    }
    return {composedData, imageUri}
  }

  const createDisplayContent = (obj) => {
    const displayContentObj = obj?.displayContent || {}

    const displayContent = {}

    Object.keys(displayContentObj).forEach((langKey) => {
      displayContent[langKey] = {
        targetType: displayContentObj?.[langKey]?.targetType,
        title: displayContentObj?.[langKey]?.title,
        category: displayContentObj?.[langKey]?.category,
        parentCategory: displayContentObj?.[langKey]?.parentCategory,
        childCategory: displayContentObj?.[langKey]?.childCategory,
        excerpt: displayContentObj?.[langKey]?.excerpt,
        terms: displayContentObj?.[langKey]?.terms,
        titleValid: displayContentObj?.[langKey]?.titleValid,
        excerptValid: displayContentObj?.[langKey]?.excerptValid,
        termsValid: displayContentObj?.[langKey]?.termsValid,
      }
    })
    return displayContent
  }
  const transformCategories = async(ruleSet) => {
    if (
      !ruleSet?.rules?.[0]?.includedCategories
    ) {
      return [];
    }
    const includedCategoryIds = ruleSet.rules[0].includedCategories;
    if(includedCategoryIds.length>0){
      const categoryList = await fetchCategoryList();
        const cats = categoryList
          .filter(cat => includedCategoryIds.includes(cat.category))
          .map(cat => ({
            ...cat,
            displayText: cat.category
          }));
          return cats
      }
      return []
  };

  const fetchImage = async (imageUri) => {
    let response = null;
    let url = null;
    try {
      response = await getSalesTargetsDownloadMedia("filePath=" + imageUri);
      url = URL.createObjectURL(response);
    } catch (error) {
      console.error('Download error:', error);
    }
    return url;
  }
  let changeParam = id
  const getParam = (urlStatus)=>{
   return  urlStatus === Constants.Draft ? 'uuid' : 'id';
  }
  const validResonse = (response) => {
    return response.data.length > 0 || response?.data?.content?.length > 0
  }
  const getProductUploadedFlag = (response) => {
    return  response?.data?.[0]?.metadata?.isProductIdsUploaded
  }
  const getDraftProductUploadedFlag = (response) => {
    return response?.data?.content?.[0]?.versionData?.metadata?.isProductIdsUploaded 
  }

  const checkDraftPreRequisite = (response) => {
   return (response?.data?.content?.[0]?.versionData?.targetType == 'Monthly Prerequisite Target' || response?.data?.content?.[0]?.versionData?.targetType == 'Product Prerequisite Target')
  }
  const checkPreRequisite = (response) => {
    return (response?.data?.[0]?.targetType == 'Monthly Prerequisite Target' || response?.data?.[0]?.targetType == 'Product Prerequisite Target')
  }
  const doesImageUrlExists = (responseData)=>{
    return responseData?.media?.[0]?.imageUrl
  }

  const getDisplayContentMedia = (responseData) => {
    return responseData?.media?.[0] || {};
  }
  // this will reset redux salestarget when its published state
  const getPublishedComposedData = async (response, formData, dataList, displayContent, childDisplayContent, imageUri) => {
    const responseData = response?.data?.[0];
    const displayContentMedia = getDisplayContentMedia(responseData);
    return {
      ...dataList, formData: formData, ruleSet: responseData?.ruleSet,
      displayContent: {...displayContent,child:childDisplayContent},
      targetName: responseData?.targetName,
      child: { displayContent: childDisplayContent },
      status: responseData?.status,
      pointDisplay: responseData?.pointDisplay,
      joinCampaignFlag: responseData?.joinCampaignFlag,
      uuid: responseData?.uuid || null,
      displayContentMedia: {
        ...displayContentMedia,
        title: displayContentMedia?.title,
        imageUrl: displayContentMedia?.imageUrl,
        imageUri: imageUri,
        imageId: displayContentMedia?.imageId,
      },
      targetType: TARGET_TYPES_OPTIONS[responseData?.targetType],
      targetTypeValue: responseData?.targetType,
      tabWiseData: {
        parent: {
          includedProducts: responseData?.ruleSet?.rules?.[0]?.includedProductIds,
          excludedProducts: responseData?.ruleSet?.rules?.[0]?.excludedProductIds,
          ruleSet: responseData?.ruleSet,
          mediaFile: responseData?.metadata?.isProductIdsUploaded ? [responseData?.metadata?.productFileName] : [],
          selectedCategory:  await transformCategories(responseData?.ruleSet),
          ignoreSkuList: responseData?.ignoreSkuList
        },
        child: {
          includedProducts: responseData?.children?.[0]?.ruleSet?.rules?.[0]?.includedProductIds,
          excludedProducts: responseData?.children?.[0]?.ruleSet?.rules?.[0]?.excludedProductIds,
          ruleSet: responseData?.children?.[0]?.ruleSet,
          mediaFile: responseData?.children?.[0]?.metadata?.isProductIdsUploaded ? [responseData?.children?.[0]?.metadata?.productFileName] : [],
          selectedCategory:  await transformCategories(responseData?.children?.[0]?.ruleSet),
          ignoreSkuList: responseData?.children?.[0]?.ignoreSkuList
        }
      },
      awardPointsImmedFlag:responseData?.awardPointsImmedFlag,
      media: responseData?.media
    }
  }
  // let [loading, setLoading] = useState(false)
  const getSalesDataById = useCallback(
    async id => {
      try {
        changeParam = getParam(urlStatus);
        // setLoading(true)
        const response = await getSalesTargetData(`${changeParam}=${id}`);
        // setLoading(false)
        let imageUri = null;

        let parentRulesObj = null;
        let childRulesObj = null;
        let responseData;
        if (validResonse(response)) {
          let composedData = {};
          if (urlStatus === Constants.Draft) {
            responseData  = response?.data?.content[0]?.versionData;
            const d  = await getComposedData(response);
            composedData = d.composedData;
            dispatch(setSalesTarget(composedData))
            dispatch(setSalesTargetUuid(composedData.uuid))
            if (getDraftProductUploadedFlag(response)) {
              dispatch(setSelectedType(Constants?.UploadedProducts));
              setPreRequisiteParentTab({
                categoryTable: false,
                uploadFile: true
              });
            } else {
              dispatch(setSelectedType(Constants?.CategoryProducts));
              setPreRequisiteParentTab({
                categoryTable: true,
                uploadFile: false
              });
            }
            if (checkDraftPreRequisite(response) && responseData?.child?.metadata?.isProductIdsUploaded) {
              setPreRequisiteChildTab({
                categoryTable: false,
                uploadFile: true
              });
            } else {
              setPreRequisiteChildTab({
                categoryTable: true,
                uploadFile: false
              });
            }

          } else {
            responseData = response?.data?.[0]
              if(doesImageUrlExists(responseData)) {
              imageUri = responseData?.media[0]?.imageUrl;
            }
            const formData = createFormData(responseData);
            const displayContent = createDisplayContent(responseData);
            const childDisplayContent = createDisplayContent(responseData?.children?.[0] || {});
            setSalesTargetType(responseData.targetType);
            composedData = await getPublishedComposedData(response, formData, dataList,displayContent, childDisplayContent, imageUri)
            dispatch(setSalesTarget(composedData))
            dispatch(setSalesTargetUuid(composedData.uuid))
            if (getProductUploadedFlag(response)) {
              dispatch(setSelectedType(Constants?.UploadedProducts));
              setPreRequisiteParentTab({
                categoryTable: false,
                uploadFile: true
              });
            } else {
              dispatch(setSelectedType(Constants?.CategoryProducts));
              setPreRequisiteParentTab({
                categoryTable: true,
                uploadFile: false
              });
            }

            if (checkPreRequisite(response) && responseData?.children?.[0]?.metadata?.isProductIdsUploaded) {
              setPreRequisiteChildTab({
                categoryTable: false,
                uploadFile: true
              });
            } else {
              setPreRequisiteChildTab({
                categoryTable: true,
                uploadFile: false
              });
            }
          }

          if (urlStatus === Constants.Draft) {
            parentRulesObj = responseData?.ruleSet?.rules?.[0];
          } else {
            parentRulesObj = response?.data[0]?.ruleSet?.rules?.[0];
          }

          if (urlStatus === Constants.Draft) {
            if (responseData?.child?.ruleSet?.rules?.[0]) {
              childRulesObj = responseData?.child?.ruleSet?.rules?.[0];
            }
          } else {
            if (response?.data[0]?.children && response?.data[0]?.children.length > 0) {
              childRulesObj = response?.data[0]?.children?.[0]?.ruleSet?.rules?.[0];
            }
          }

          // Extract parent and child product IDs
          const parentIncludedIds = parentRulesObj?.includedProductIds || [];
          const parentExcludedIds = parentRulesObj?.excludedProductIds || [];

          const childIncludedIds = childRulesObj?.includedProductIds || [];
          const childExcludedIds = childRulesObj?.excludedProductIds || [];
          const childAllProductIds = [...childIncludedIds, ...childExcludedIds];

          setEditModeProductIds({
            includedIds: parentIncludedIds,
            excludedIds: parentExcludedIds,
            childIncludedIds: childIncludedIds,
            childExcludedIds: childExcludedIds
          });

          const combinedIncludedIds = childAllProductIds.length > 0 ?
            [...parentIncludedIds, ...childIncludedIds] :
            parentIncludedIds;

          const combinedExcludedIds = childAllProductIds.length > 0 ?
            [...parentExcludedIds, ...childExcludedIds] :
            parentExcludedIds;

          // Create a single rule set with combined product IDs
          const updatedRuleSet = {
            includeAllProductsByDefault: parentRulesObj?.includeAllProductsByDefault || false,
            skipNonAssorted: false,
            rules: [
              {
                includedCategories: parentRulesObj?.includedCategories || [],
                includedProductIds: combinedIncludedIds,
                excludedCategories: parentRulesObj?.excludedCategories || [],
                excludedProductIds: combinedExcludedIds
              }
            ]
          };

          dispatch(setRuleSet({ ruleSet: updatedRuleSet }));
          dispatch(setInitialTargetName(composedData.targetName))
          setListData(composedData)
          dispatch(setTargetType(composedData.targetType))
          dispatch(
            setToastNotifications({ show: true, message: ' Sales Target data fetched succesfully', type: 'success' })
          )
        } else dispatch(setToastNotifications({ show: true, message: 'Sales Target data not fetched', type: 'error' }))
      } catch (err) {
        // setLoading(false)
        console.log(err)
      }
    },
    [dataList, dispatch]
  )
  useEffect(() => {
   ( async()=>{
    const data = await fetchCategoryList();
    setCategoryList(data);
    })()
  }, [])

  useEffect(() => {
    if (id) {
      getSalesDataById(id)
      setIsReadOnly(true)
      // get language
      getDisplayContentLanguagesService().then(res => {
        dispatch(setLanguages(res))
      })
    }
  }, [id])

  useEffect(() => {
    if (id && productListData?.data?.length) {
      let dataWithIncluded = productListData.data.map(product => ({ ...product }))
      dispatch(setSalesTargetFormData({ selectedSalesTargetProduct: dataWithIncluded }))
    }
  }, [id, productListData])

  const onClickPrimaryButton = () => {
    dispatch(resetSalesTarget())
    navigate(ROUTES.SALES_TARGETS)
  }

  const onClickSecondaryButton = () => {
    setIsCancel(!isCancel)
  }

  //Handle duplicate sales target action
  const handleDuplicate = (route) => {
    if (dataList.formData) {
      const updatedDataList = JSON.parse(JSON.stringify(dataList));
      // Set status to null so when user come back to review page they get the edit option
      updatedDataList.status = null;

      // Reset target name
      updatedDataList.formData.targetName = null;
      updatedDataList.formData.targetNameValid = true;
      updatedDataList.formData.awardPointsImmedFlag = updatedDataList.awardPointsImmedFlag;

      // Reset active display
      if (updatedDataList.formData.startDate == updatedDataList.formData.displayStartDate &&
        updatedDataList.formData.endDate == updatedDataList.formData.displayEndDate) {
        updatedDataList.formData.activeDisplay = true;
      }

      // Reset award point
      // updatedDataList.formData.awardPointsImmedFlag = updatedDataList.formData.targetDeliveryDate == updatedDataList.formData.pointsDeliveryDate;

      // Reset validation flags
      updatedDataList.formData.startDateValid = false;
      updatedDataList.formData.endDateValid = false;
      updatedDataList.formData.displayStartDateValid = false;
      updatedDataList.formData.displayEndDateValid = false;
      updatedDataList.formData.targetDeliveryDateValid = false;
      updatedDataList.formData.pointsDeliveryDateValid = false;

      // Reset selection flags
      updatedDataList.formData.isNumberOfLevelsSelected = false;
      updatedDataList.formData.isNumberOfMilestonesSelected = false;

      // Reset dates if start date is in the past
      if (new Date(updatedDataList.formData.startDate) <= new Date()) {
        updatedDataList.formData.displayStartDate = null;
        updatedDataList.formData.displayEndDate = null;
        updatedDataList.formData.startDate = null;
        updatedDataList.formData.endDate = null;
        updatedDataList.formData.targetDeliveryDate = null;
        updatedDataList.formData.pointsDeliveryDate = null;

        updatedDataList.formData.startDateValid = undefined;
        updatedDataList.formData.endDateValid = undefined;
        updatedDataList.formData.displayStartDateValid = undefined;
        updatedDataList.formData.displayEndDateValid = undefined;
        updatedDataList.formData.targetDeliveryDateValid = undefined;
        updatedDataList.formData.pointsDeliveryDateValid = undefined;
      }

      // Restore Target CSV File
      updatedDataList.storeList = updatedDataList.formData.storeList;
      updatedDataList.formData.targetMediaFile = [updatedDataList.storeList];

      // Dispatch the updated state to Redux
      dispatch(setSalesTarget(updatedDataList));
      navigate(route, { state: { isEdit: true } });
    } else {
      navigate(route, { state: { isEdit: true } });
    }
  }

  const editDraftEntries = (route) => {
    if (dataList.formData && urlStatus === Constants?.Draft) {
      const updatedDataList = JSON.parse(JSON.stringify(dataList));
      updatedDataList.formData.targetName = updatedDataList.targetName;
      updatedDataList.formData.targetNameValid = false;

      const validateValue = (value, setter) => {
        if (value && typeof value !== 'undefined' && value !== '') {
          setter(false);
        } else {
          setter(undefined);
        }
      };
      validateValue(updatedDataList.formData.startDate, (value) => (updatedDataList.formData.startDateValid = value));
      validateValue(updatedDataList.formData.endDate, (value) => (updatedDataList.formData.endDateValid = value));
      validateValue(updatedDataList.formData.displayStartDate, (value) => (updatedDataList.formData.displayStartDateValid = value));
      validateValue(updatedDataList.formData.displayEndDate, (value) => (updatedDataList.formData.displayEndDateValid = value));
      validateValue(updatedDataList.formData.targetDeliveryDate, (value) => (updatedDataList.formData.targetDeliveryDateValid = value));
      validateValue(updatedDataList.formData.pointsDeliveryDate, (value) => (updatedDataList.formData.pointsDeliveryDateValid = value));

      updatedDataList.formData.isNumberOfLevelsSelected = false;
      updatedDataList.formData.isNumberOfMilestonesSelected = false;
      updatedDataList.storeList = updatedDataList.formData.storeList;
      updatedDataList.formData.targetMediaFile = [updatedDataList.storeList];
      updatedDataList.initialTargetName = salesTargetData.initialTargetName;
      updatedDataList.uuid = salesTargetData.uuid; // Preserve UUID
      dispatch(setSalesTarget(updatedDataList))
      navigate(route, { state: { isEdit: true } })
    } else {
      navigate(route,{ state: { isEdit: true } })
    }
  }
  const handleDownload = async () => {
    if (!id || urlStatus === Constants.Draft) return;
    try {
      const data = await getSalesTargetsReporteDownload(`salesTargetId=${id}`);
      const fileName = `SalesTarget_Report${getDateWithTimeString()}`;
      downloadCSVFiles(data, fileName);
    } catch (error) {
      dispatch(setToastNotifications({ show: true, message: 'Failed to download report', type: 'error' }));
    }
  };

  const editPanel = (route) => {
    editDraftEntries(route);
  }
  const handleSetActiveTab = () => {
    dispatch(setPageActiveTab({ activeTab: 'parent', pageTitle: 'Products' }));
  }
  return (
    <>
      <Breadcrumb
        uiSchema={{
          isDark: true,
          className: 'mb-5',
          breadcrumbs: [
            {
              href: '/',
              label: '',
            },
            {
              href: '',
              label: 'Loyalty Campaigns',
            },
            {
              href: '',
              label: 'Sales Target',
            },
            {
              href: '',
              label: `Add Sales Target ${countryName}`,
            },
          ],
        }}
        id={'str_bradcrumb'}
      />
      <PageHeader title={isReadOnly ? `Sales Target ${countryName}`: 'Add Sales Target'} />
      <>
        {!isReadOnly && <ProgressIndicator
          currentStep={4}
          completed={false}
          steps={4}
          titles={[{ title: 'Setup' }, { title: 'Display Content' }, { title: 'Products' }, { title: 'Review' }]}
          className="mb-6"
        />}
        {isReadOnly && <ReviewActionHeader
          completedDate={urlStatus !== Constants.Draft ? dataList?.formData?.activeEndDate ?? dataList?.formData?.endDate ?? "" : ""}
          onDuplicate={handleDuplicate}
          onDownload={handleDownload}
          isDuplicateEnabled={urlStatus !== Constants.Draft}
        />
        }
        <br />
        <ReviewAccordion
          salesTargetData={dataList}
          isOpenStoreListModal={isOpenStoreListModal}
          setOpenStoreListModal={setOpenStoreListModal}
          languages={languages}
          handleTabClick={handleTabClick}
          activeLanguage={activeLanguage}
          editPanel={editPanel}
          status={dataList?.status}
          preRequisiteParentTab={preRequisiteParentTab}
          preRequisiteChildTab={preRequisiteChildTab}
          handleSetActiveTab={handleSetActiveTab}
          getFilteredProducts={getFilteredProducts}
          onTemplateUpdate={onTemplateUpdate}
          salesTargetId={id}
        />

        {isCancel ? (
          <Modal
            type={MODAL_TYPE.FLUID}
            showModal={isCancel}
            onCloseModal={handleCancel}
            title="Are you sure you want to cancel?"
            text={'Your work will not be saved if you click Yes. To continue editing and go back to the page, click NO'}
            showPrimaryButton={true}
            primaryButtonText="Yes"
            onClickPrimaryButton={onClickPrimaryButton}
            showSecondaryButton={true}
            secondaryButtonText="No"
            onClickSecondaryButton={onClickSecondaryButton}
            footerProps={{
              size: 'medium',
              type: 'primary',
            }}
            isDark={true}
          />
        ) : null}
        {!id ? (
          <SaveCancelFooter
            isReview={true}
            handleCancel={handleCancel}
            draftAction={handleDraftAction}
            nextAction={handlePublishAction}
          />
        ) : null}
      </>
    </>
  )
}
